var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"layout"}},[_c('the-app-bar'),_c('the-side-menu'),_c('the-content'),_c('the-loader'),_c('the-notifications')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }